import { useEffect, useState } from "react";

import { Shield, Package, Truck, Zap, TrendingDown } from "lucide-react";

import theme from "../../styles/__theme";
import { isMobile as isMobileDetection } from "../../utils/mobileDetection";

import {
	LoaderContainer,
	ContentWrapper,
	LogoContainer,
	LogoWrapper,
	Heading,
	SubHeading,
	CarouselContainer,
	FeatureCard,
	IconBox,
	FeatureText,
	ProgressBarContainer,
	ProgressBar,
	InstructionText,
} from "./authLoader.styles";

const { colors } = theme;

const features = [
	{
		icon: TrendingDown,
		title: "Ship bulk orders starting at just Rs.6/kg",
		color: "light-purple",
	},
	{
		icon: Shield,
		title: "Secure handling and insurance options",
		color: "light-purple",
	},
	{
		icon: Package,
		title: "Handle shipments up to 50kgs with ease",
		color: "light-purple",
	},
	{
		icon: Truck,
		title: "Nationwide coverage with trusted partners",
		color: "light-purple",
	},
	{
		icon: Zap,
		title: "Real-time tracking for all cargo shipments",
		color: "light-purple",
	},
];

export default function AuthLoader() {
	const isMobile = isMobileDetection();
	const [currentIndex, setCurrentIndex] = useState(
		Math.floor(Math.random() * features.length)
	);
	const [isAnimating, setIsAnimating] = useState(false);

	useEffect(() => {
		const interval = setInterval(() => {
			setIsAnimating(true);
			setTimeout(() => {
				setCurrentIndex((prev) => {
					let newIndex;
					do {
						newIndex = Math.floor(Math.random() * features.length);
					} while (newIndex === prev && features.length > 1);
					return newIndex;
				});
				setIsAnimating(false);
			}, 300);
		}, 2000);

		return () => clearInterval(interval);
	}, []);

	const currentFeature = features[currentIndex];
	const Icon = currentFeature.icon;

	return (
		<LoaderContainer>
			<ContentWrapper>
				<LogoContainer>
					<LogoWrapper>
						<img
							src="/assets/img/SR Cargo213.svg"
							alt="Shiprocket Cargo"
							height={120}
							width={120}
						/>
					</LogoWrapper>
				</LogoContainer>

				<Heading>Getting your Cargo services ready</Heading>
				<SubHeading>
					Setting things up for a smooth shipping experience.
				</SubHeading>

				<CarouselContainer>
					<FeatureCard isAnimating={isAnimating}>
						<IconBox>
							<Icon
								size={isMobile ? 24 : 32}
								color={colors.purple}
								strokeWidth={2}
							/>
						</IconBox>
						<FeatureText>{currentFeature.title}</FeatureText>
					</FeatureCard>
				</CarouselContainer>

				<ProgressBarContainer>
					<ProgressBar />
				</ProgressBarContainer>

				<InstructionText>
					This will only take a moment. Please don't refresh or close this
					window.
				</InstructionText>
			</ContentWrapper>
		</LoaderContainer>
	);
}
